"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _reactBootstrap = require("react-bootstrap");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * A BlogList component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A BlogList
 */
function BlogList(props) {
  if (!props.rendering.fields) {
    return null;
  }
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var [error, setError] = (0, _react.useState)(null);
  var [isLoaded, setIsLoaded] = (0, _react.useState)(false);
  var [items, setItems] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    fetch("/apicalls/bloglist/?tag=".concat(extractedFields.Tag.value, "&num=").concat(extractedFields.NumberOfPosts.value)).then(res => res.json()).then(result => {
      setIsLoaded(true);
      setItems(result);
    }, error => {
      setIsLoaded(true);
      setError(error);
    });
  }, []);
  if (isLoaded && (0, _lodash.isNull)(error)) {
    var _items$bloglist;
    var data = (_items$bloglist = items.bloglist) === null || _items$bloglist === void 0 ? void 0 : _items$bloglist.blogPost;
    if (data && data.length > 0) {
      var viewAllLink = (0, _lodash.isEmpty)(extractedFields.Tag.value) ? items.bloglist.blogLandingLink : "".concat(items.bloglist.blogLandingLink, "/topic/").concat(extractedFields.Tag.value);
      viewAllLink = (0, _lodash.toLower)(viewAllLink).replaceAll(' ', '-');
      var Author = props => {
        if (props.author && props.author.length > 0) {
          var authorCount = props.author.length;
          var separatorText = authorCount === 2 ? ' and ' : ', ';
          return /*#__PURE__*/_react.default.createElement("p", {
            className: "blog-author caption"
          }, (0, _lodash.map)(props.author, (author, key) => {
            return /*#__PURE__*/_react.default.createElement("section", {
              key: "blog-author-".concat(key)
            }, /*#__PURE__*/_react.default.createElement("a", {
              key: props.index + '_' + key,
              href: author.link,
              target: "_blank",
              rel: "noreferrer"
            }, author.name), authorCount - 1 > Number(key) && separatorText);
          }), /*#__PURE__*/_react.default.createElement("span", null, props.postDate));
        } else return null;
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "bloglist app-container"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, (0, _lodash.map)(data, (blog, key) => {
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          lg: 4,
          key: key
        }, /*#__PURE__*/_react.default.createElement("section", {
          className: "mm-content-object"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "mm-media-object"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "body"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "title",
          style: {
            wordBreak: 'break-word'
          }
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: blog.link,
          target: "_blank",
          rel: "noreferrer"
        }, blog.title)), /*#__PURE__*/_react.default.createElement(Author, {
          author: blog.author,
          postDate: blog.postDate,
          index: key
        })), !(0, _lodash.isEmpty)(blog.img) && /*#__PURE__*/_react.default.createElement("picture", {
          className: "mm-img-square--xl"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: blog.img.src,
          alt: blog.img.alt
        })))));
      })), extractedFields.ViewAllPostsCheck.value && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
        className: "justify-content-center"
      }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: "link",
        href: encodeURI(viewAllLink),
        target: "_blank",
        label: extractedFields.ViewAllPostsText.value,
        dataId: 'blog-view-all'
      }))));
    }
  }
  return null;
}
var _default = exports.default = BlogList;